// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.machines-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
  flex-wrap: wrap;
}
.machines-header .search-container {
  flex: 1 1;
  min-width: 300px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}
.empty-state p {
  margin-top: 16px;
  font-size: 16px;
}

.machine-device-hwid {
  font-size: 0.7rem;
  color: #667085;
  line-height: 1.2;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.machine-form .form-group {
  margin-bottom: 20px;
}
.machine-form .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}
.machine-form .form-group textarea.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
}
.machine-form .form-group textarea.form-control:focus {
  outline: none;
  border-color: #007bff;
}
.machine-form .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Machines/Machines.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACF;AACE;EACE,SAAA;EACA,gBAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAAF;AAEE;EACE,kCAAA;AAAJ;AAGE;EACE,gBAAA;EACA,eAAA;AADJ;;AAKA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAHF;AAKE;EACE,gBAAA;EACA,eAAA;AAHJ;;AAOA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,QAAA;AAJF;;AAQE;EACE,mBAAA;AALJ;AAOI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AALN;AAQI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AANN;AAQM;EACE,aAAA;EACA,qBAAA;AANR;AAWE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AATJ","sourcesContent":[".machines-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n  flex-wrap: wrap;\n\n  .search-container {\n    flex: 1;\n    min-width: 300px;\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n\n  .spin {\n    animation: spin 1s linear infinite;\n  }\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #999;\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n.machine-device-hwid {\n  font-size: 0.7rem;\n  color: #667085;\n  line-height: 1.2;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.machine-form {\n  .form-group {\n    margin-bottom: 20px;\n\n    label {\n      display: block;\n      margin-bottom: 8px;\n      font-weight: 600;\n      font-size: 14px;\n      color: #333;\n    }\n\n    textarea.form-control {\n      width: 100%;\n      padding: 10px;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n      font-family: inherit;\n      font-size: 14px;\n      resize: vertical;\n\n      &:focus {\n        outline: none;\n        border-color: #007bff;\n      }\n    }\n  }\n\n  .modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 1px solid #e0e0e0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
